import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Rect,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Rect, { width: "12", height: "18", x: "6", y: "3", rx: "6", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M12 7v4", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Mouse";
const Mouse = memo(themed(Icon));
export {
  Mouse
};
//# sourceMappingURL=mouse.js.map
